module.exports = __webpack_public_path__ + "static/media/email-dark.ad8708a9.svg";